import { DateTime, DurationInput } from "luxon";

import { formatTimeRangeV2 } from "src/shared/utils/formatTime";
import { THackerAPIDatetime } from "src/shared/utils/hackerapi";
import { timesToOptionsExplicitV2 } from "src/shared/utils/react-select";

export const isWorkshopTimesOut = true;

const API_WORKSHOP_TIMES: [THackerAPIDatetime, DurationInput][] = [
  [DateTime.utc(2026, 9, 19, 3, 0, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 3, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 4, 0, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 4, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 5, 0, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 5, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 14, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 16, 0, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 16, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 17, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 18, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 19, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 20, 30, 0).toISO(), { minutes: 30 }],
];

export const TIME_OPTIONS = [
  ...timesToOptionsExplicitV2(formatTimeRangeV2, API_WORKSHOP_TIMES),
  { label: "", value: "" },
];
